import toggleAccordion from './components/toggleAccordion'

document.addEventListener(
  'DOMContentLoaded',
  () => {
    toggleAccordion()
  },
  false
)
